(ns app.front.dashboard.common
  (:require [core.front.carbon :as cc]))


(def link-box-container
  :div.flex.flex-wrap.-mx-2.-mt-3)


(defn link-box
  ([props] (link-box props nil))
  ([{:keys [href title-1 title on-click uppercase? aria-label]
     :or   {on-click (fn [_])}}
    content]
   [:div.flex.flex-col.w-full.md:w-1-2.lg:w-1-3.px-2.mt-3
    (when title-1 [:h3.mb-2 title-1])
    [:div.flex
     [:a.flex.w-full.rounded.items-center.justify-between.p-6.bg-ui-light-gray.text-black.no-underline.hover:bg-ui-blue-10
      {:href       href
       :on-click   on-click
       :class      (when uppercase? "uppercase")
       :aria-label aria-label}
      [:span title]
      content]]]))


(defn link-box-with-number [{:keys [loading?] :as props} amount]
  [link-box (assoc props :uppercase? true)
   [:div {:style {:height "14px"}}
    (if loading?
      [:span (cc/inline-loading {:class-name "min-h-0"})]
      [:strong amount])]])
